import React from 'react';

import { TerminationGeneratorEnum } from 'app/shared/enums';
import { useStyles } from './TerminationPreviewDocument.styles';
import { useTerminationPreviewDocument } from './useTerminationPreviewDocument';
import { TerminationPreviewField } from 'app/components/TerminationPreviewField';

export default function TerminationPreviewDocument() {
  const classes = useStyles();

  const {
    data: {
      carData,
      carRegistrationNumber,
      cityAndDate,
      fullAddress,
      fullName,
      previousInsurerName,
      previousInsurerCity,
      previousInsurerStreet,
      previousPolicyNumber,
      cityAndZipCode,
      terminationReason,
    },
    isSecondSectionFilled,
    isThirdSectionFilled,
    isFirstSectionFilled,
  } = useTerminationPreviewDocument();

  return (
    <div className={classes.a4paper}>
      <div className={classes.waterMark}>
        <div className={classes.waterMarkText}>
          {TerminationGeneratorEnum.Example}
        </div>
      </div>
      <div className={classes.documentFirstSection}>
        <TerminationPreviewField
          value={isSecondSectionFilled ? cityAndDate : ''}
          label={TerminationGeneratorEnum.TerminationPreviewLabel1}
        />
        <TerminationPreviewField
          value={isThirdSectionFilled ? previousInsurerName : ''}
          label={TerminationGeneratorEnum.TerminationPreviewLabel2}
        />
        <TerminationPreviewField
          value={isThirdSectionFilled ? previousInsurerStreet : ''}
          label={''}
        />
        <TerminationPreviewField
          value={isThirdSectionFilled ? previousInsurerCity : ''}
          label={TerminationGeneratorEnum.TerminationPreviewLabel3}
        />
      </div>
      <div>
        <div className={classes.documentSectionTitle}>
          {TerminationGeneratorEnum.Section1}
        </div>
        <TerminationPreviewField
          value={isSecondSectionFilled ? fullName : ''}
          label={TerminationGeneratorEnum.TerminationPreviewLabel4}
        />
        <TerminationPreviewField
          value={isSecondSectionFilled ? fullAddress : ''}
          label={TerminationGeneratorEnum.TerminationPreviewLabel5}
        />
        <TerminationPreviewField
          value={isSecondSectionFilled ? cityAndZipCode : ''}
          label={TerminationGeneratorEnum.TerminationPreviewLabel6}
        />
        <div className={classes.documentSectionTitle}>
          {TerminationGeneratorEnum.Section2}
        </div>
        <TerminationPreviewField
          value={isFirstSectionFilled ? carData : ''}
          label={TerminationGeneratorEnum.TerminationPreviewLabel7}
        />
        <TerminationPreviewField
          value={isFirstSectionFilled ? carRegistrationNumber : ''}
          label={TerminationGeneratorEnum.TerminationPreviewLabel8}
        />
        <TerminationPreviewField
          value={isThirdSectionFilled ? previousPolicyNumber : ''}
          label={TerminationGeneratorEnum.TerminationPreviewLabel9}
        />
      </div>
      <div>
        <div className={classes.documentThirdSectionTitle}>
          Wypowiedzenie umowy ubezpieczenia OC
        </div>
        <div className={classes.documentThirdSectionText}>
          {isThirdSectionFilled && terminationReason}
        </div>
      </div>
      <div className={classes.signature}>
        <TerminationPreviewField
          value={''}
          label={TerminationGeneratorEnum.TerminationSignature}
          width={150}
        />
      </div>
      <p className={classes.documentInfo}>
        {TerminationGeneratorEnum.TerminationDocumentInfo}
      </p>
    </div>
  );
}
